import React from "react";
import DefaultReportTemplate from "../defaultReportTemplate";
import dayjs from "dayjs";
import FormatDate from "../../masters/DateFormater";
import { Icon } from "../../../components/Component";
import { Tooltip } from "antd";
import { formatCurrency, formatCurrency2 } from "../../../utils/Utils";
import { useLocation, useNavigate, useParams } from "react-router";

function SupplierBalancesDetailReport() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const name = location.state?.name;

  const columns: any = [
    {
      title: "Invoice #",
      dataIndex: "invoiceId",
      width: 200,
      fixed: "left",
      render(text: any, record: any) {
        return (
          <span
            className="inlineTableCellLink"
            onClick={() => {
              navigate(`/invoice-preview-report/${record.invoiceNumber}`, {
                state: {
                  previousPath: `/supplierBalancesDetailReport/${id}`,
                  name,
                },
              });
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      width: 150,
      render: (date: any) => <span>{date ? FormatDate(date) : "N/A"}</span>,
    },
    {
      title: "due Date",
      dataIndex: "dueDate",
      width: 150,
      render: (date: any) => <span>{date ? FormatDate(date) : "N/A"}</span>,
    },
    {
      title: "GRN Date",
      dataIndex: "grnDate",
      width: 150,
      render: (date: any) => <span>{date ? FormatDate(date) : "N/A"}</span>,
    },
    {
      title: "Payment Days",
      dataIndex: "paymentDays",
      key: "paymentDays",
      width: 160,
      // render: (paymentDays: any) => <span>{paymentDays} days</span>,
      render: (text: any, record: any) => {
        //  "flag": "overDue",
        const isHighlighted = record?.dueType == "overDue";
        let placeholder = "";
        if (record?.dueType == "overDue") {
          placeholder = "OVERDUE BY " + Number(record?.aging) + " DAYS";
        } else {
          if (record?.dueType == "Paid") {
            placeholder = "PAID";
          } else {
            if (record?.aging == 0) {
              placeholder = "DUE TODAY";
            } else {
              placeholder = "DUE IN " + Number(record?.aging) + " DAYS";
            }
          }
        }
        return (
          <div
            className="align-left"
            style={{
              color: isHighlighted ? "lightcoral" : "green",
              backgroundColor: isHighlighted ? "white" : "inherit",
              padding: "4px",
              borderRadius: "4px",
            }}
          >
            {placeholder}
          </div>
        );
      },
    },
    {
      title: "Invoice Amount Without Tax",
      dataIndex: "invAmountWithoutTax",
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          {formatCurrency(text?.toString(), record?.currencyCode)}
        </div>
      ),
    },
    {
      title: "Invoice Amount With Tax",
      dataIndex: "invAmountWithTax",
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          {formatCurrency(text?.toString(), record?.currencyCode)}
        </div>
      ),
    },
    {
      title: "Paid Amount",
      dataIndex: "paidAmount",
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          {formatCurrency(text?.toString(), record?.currencyCode)}
        </div>
      ),
    },
    {
      title: "Outstanding Amount",
      dataIndex: "outstandingAmount",
      width: 200,
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          {formatCurrency(text?.toString(), record?.currencyCode)}
        </div>
      ),
    },
    {
      title: "Overdue Amount",
      dataIndex: "overDueAmount",
      render: (text: any, record: any) => (
        <div style={{ textAlign: "right" }}>
          {formatCurrency(text?.toString(), record?.currencyCode)}
        </div>
      ),
    },
    {
      title: "Payment Status",
      dataIndex: "paymentStatus",
      width: 150,
    },
  ];
  return (
    <DefaultReportTemplate
      pageTitle={`${name} - Balances, Detail Report`}
      moduleKey="supplierBalancesDetailReport"
      columns={columns}
      filtersOption={{
        site: false,
        contractor: false,
        dateRange: false,
        aging: false,
      }}
      previousPath="/supplier-balances-report"
      extra={{
        tableScrollX: 1850,
        id,
      }}
    />
  );
}

export default SupplierBalancesDetailReport;
